import AddInventoryContainer from "./AddInventoryContainer";

export default AddInventoryContainer;
